/*eslint-env jquery*/
import React, { Component } from 'react'
import 'react-select/dist/react-select.css'
import Select from 'react-select'

class FormSelect extends Component {
    render() {
        return (
            <Select {...this.props} />
        )
    }
}

FormSelect.defaultProps = {
    options: [],
    placeholder: 'Select'
}

export default FormSelect;


// WEBPACK FOOTER //
// ./src/components/FormSelect.js